import { SafeMarkdown } from "@/components/markdown/SafeMarkdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

export function SandboxMarkdown({ content }: { content: string }) {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none">
      <SafeMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code(props) {
            const { children, className } = props;
            return (
              <code className={cn("rounded bg-muted px-1 py-0.5 font-mono text-xs", className)}>
                {children}
              </code>
            );
          },
          pre(props) {
            return <pre className="overflow-auto rounded-md border border-border bg-muted p-3">{props.children}</pre>;
          },
        }}
      >
        {content}
      </SafeMarkdown>
    </div>
  );
}
